export default "__VITE_ASSET__896c3e60__"